import { oauthSetupSteps } from "../oauthSetupSteps";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const polar = defineConnector({
  identifier: "polar",
  name: "Polar",
  tagLine: "Billing, subscriptions, and customer data",
  logo,
  tags: ["data"],
  protocol: "http",
  defaultUrlPattern: () => "https://api\\.polar\\.sh/v1/.*",
  auth: oauthAuth,
  steps: oauthSetupSteps({
    identifier: "polar",
    registrationUrl: "https://polar.sh/dashboard",
    scopes: ["openid", "profile"],
  }),
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://polar.sh/oauth2/authorize",
    tokenEndpoint: () => "https://api.polar.sh/v1/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["openid", "profile"],
    pkce: () => true,
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.polar.sh/v1/oauth2/userinfo",
  },
});
